export function UndressIcon({
  size = 24,
  className = "",
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      color="currentColor"
      className={className}
      data-sentry-element="MagicWand03Icon"
      data-sentry-source-file="aside-navigation.tsx"
    >
      <path
        d="M14.4697 14.4697C14.7626 14.1768 15.2374 14.1768 15.5303 14.4697L17.0303 15.9697C17.3232 16.2626 17.3232 16.7374 17.0303 17.0303C16.7374 17.3232 16.2626 17.3232 15.9697 17.0303L14.4697 15.5303C14.1768 15.2374 14.1768 14.7626 14.4697 14.4697Z"
        fill="currentColor"
        fillRule="evenodd"
      ></path>
      <path
        d="M16.4088 16.4088C17.2872 15.5304 18.7113 15.5304 19.5897 16.4088L21.5912 18.4103C22.4696 19.2887 22.4696 20.7128 21.5912 21.5912C20.7128 22.4696 19.2887 22.4696 18.4103 21.5912L16.4088 19.5897C15.5304 18.7113 15.5304 17.2872 16.4088 16.4088Z"
        fill="currentColor"
      ></path>
      <path
        d="M13.398 1.9444C14.1704 2.34345 14.4782 3.21031 14.4791 4.11573L14.4791 4.11691L14.4898 6.7306C14.4854 6.85787 14.5465 7.1563 14.8264 7.33182L16.8227 8.58339C17.6666 9.11338 18.3782 9.89669 18.2334 10.8453C18.088 11.7978 17.1701 12.3266 16.2069 12.5708L13.6989 13.2041C13.3859 13.2831 13.2372 13.5703 13.202 13.7041L12.57 16.208C12.3275 17.1728 11.7967 18.0864 10.8442 18.2315C9.89631 18.3759 9.11178 17.6686 8.58246 16.8238L7.33148 14.8278C7.16078 14.5554 6.85974 14.4899 6.73056 14.4912L4.1148 14.4804C3.2123 14.4767 2.34719 14.1684 1.9477 13.3984C1.54687 12.6259 1.79782 11.742 2.32175 11.0063L3.71538 9.05138C3.88322 8.81595 3.84237 8.53762 3.80096 8.42788L2.86132 5.63902L2.86083 5.63754C2.56974 4.76761 2.56961 3.82402 3.19631 3.1972C3.82386 2.56953 4.76774 2.57223 5.63554 2.86655L8.42819 3.80784C8.541 3.84445 8.82319 3.87732 9.0495 3.71593L11.0055 2.32093C11.7405 1.79736 12.6248 1.54491 13.398 1.9444Z"
        fill="currentColor"
      ></path>
    </svg>
  )
}

export function HomeIcon({
  size = 24,
  className = "",
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      fill="currentColor"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="invisible_box" data-name="invisible box">
          <rect width="48" height="48" fill="none" />
        </g>
        <g id="icons_Q2" data-name="icons Q2">
          <path d="M24,2A22,22,0,1,0,46,24,21.9,21.9,0,0,0,24,2ZM34.7,14.7,28,28,14.7,34.7a1.1,1.1,0,0,1-1.4-1.4L20,20l13.3-6.7A1.1,1.1,0,0,1,34.7,14.7ZM24,22a2,2,0,1,0,2,2A2,2,0,0,0,24,22Z" />
          <path d="M24,22a2,2,0,1,0,2,2A2,2,0,0,0,24,22Zm0,0a2,2,0,1,0,2,2A2,2,0,0,0,24,22Z" />
        </g>
      </g>
    </svg>
  )
}

export function GenerateIcon({
  size = 24,
  className = "",
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      color="currentColor"
      className={className}
      data-sentry-element="AiImageIcon"
      data-sentry-source-file="aside-navigation.tsx"
    >
      <path
        d="M11.4273 2.25L11.5015 2.25C12.0184 2.25 12.5078 2.25 12.9691 2.25227C13.5082 2.25493 13.9431 2.69413 13.9405 3.23326C13.9378 3.77239 13.4986 4.20728 12.9595 4.20463C12.5034 4.20238 12.0186 4.20238 11.5 4.20238C9.28655 4.20238 7.72466 4.20446 6.54213 4.36344C5.38769 4.51865 4.74203 4.80713 4.27458 5.27458C3.80713 5.74203 3.51865 6.38769 3.36344 7.54213C3.20446 8.72466 3.20238 10.2865 3.20238 12.5C3.20238 14.7135 3.20446 16.2753 3.36344 17.4579C3.51865 18.6123 3.80713 19.258 4.27458 19.7254C4.74203 20.1929 5.38769 20.4813 6.54213 20.6366C7.72466 20.7955 9.28655 20.7976 11.5 20.7976C13.7135 20.7976 15.2753 20.7955 16.4579 20.6366C17.6123 20.4813 18.258 20.1929 18.7254 19.7254C19.1929 19.258 19.4813 18.6123 19.6366 17.4579C19.7955 16.2753 19.7976 14.7135 19.7976 12.5C19.7976 11.9814 19.7976 11.4966 19.7954 11.0405C19.7927 10.5014 20.2276 10.0622 20.7667 10.0595C21.3059 10.0569 21.7451 10.4918 21.7477 11.0309C21.75 11.4923 21.75 11.9817 21.75 12.4987V12.5727C21.75 14.6968 21.75 16.3903 21.5715 17.718C21.3872 19.089 20.9966 20.2153 20.106 21.106C19.2153 21.9966 18.089 22.3872 16.718 22.5715C15.3903 22.75 13.6968 22.75 11.5727 22.75H11.4273C9.30317 22.75 7.60974 22.75 6.28198 22.5715C4.91104 22.3872 3.7847 21.9966 2.89404 21.106C2.00337 20.2153 1.61279 19.089 1.42847 17.718C1.24996 16.3903 1.24998 14.6968 1.25 12.5727V12.4273C1.24998 10.3032 1.24996 8.60973 1.42847 7.28198C1.61279 5.91104 2.00337 4.78471 2.89404 3.89404C3.78471 3.00337 4.91104 2.61279 6.28198 2.42847C7.60973 2.24996 9.30315 2.24998 11.4273 2.25Z"
        fill="currentColor"
        fillRule="evenodd"
      ></path>
      <path
        d="M9.5 8.5C9.5 9.60457 8.60457 10.5 7.5 10.5C6.39543 10.5 5.5 9.60457 5.5 8.5C5.5 7.39543 6.39543 6.5 7.5 6.5C8.60457 6.5 9.5 7.39543 9.5 8.5Z"
        fill="currentColor"
      ></path>
      <path
        d="M18.5 1.25C18.8138 1.25 19.0945 1.4454 19.2034 1.73972L19.4613 2.43675C19.8233 3.4151 19.9388 3.68091 20.1289 3.87106C20.3191 4.06121 20.5849 4.17667 21.5633 4.53869L22.2603 4.79661C22.5546 4.90552 22.75 5.18617 22.75 5.5C22.75 5.81383 22.5546 6.09448 22.2603 6.20339L21.5633 6.46131C20.5849 6.82333 20.3191 6.93879 20.1289 7.12894C19.9388 7.31909 19.8233 7.5849 19.4613 8.56325L19.2034 9.26028C19.0945 9.5546 18.8138 9.75 18.5 9.75C18.1862 9.75 17.9055 9.5546 17.7966 9.26028L17.5387 8.56325C17.1767 7.5849 17.0612 7.31909 16.8711 7.12894C16.6809 6.93879 16.4151 6.82333 15.4367 6.46131L14.7397 6.20339C14.4454 6.09448 14.25 5.81383 14.25 5.5C14.25 5.18617 14.4454 4.90552 14.7397 4.79661L15.4367 4.53869C16.4151 4.17667 16.6809 4.06121 16.8711 3.87106C17.0612 3.68091 17.1767 3.4151 17.5387 2.43675L17.7966 1.73972C17.9055 1.4454 18.1862 1.25 18.5 1.25Z"
        fill="currentColor"
      ></path>
      <path
        d="M4.5 21.4999C8.87246 16.275 13.7741 9.384 20.9975 14.0424C20.9975 16.3323 20.9975 17.4772 20.6295 18.3825C20.1215 19.6324 19.13 20.624 17.8801 21.132C16.9747 21.4999 15.8298 21.4999 13.5399 21.4999H4.5Z"
        fill="currentColor"
      ></path>
    </svg>
  )
}

export function PremiumIcon({
  size = 24,
  className = "",
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      fill="currentColor"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g>
        <path fill="none" d="M0 0h24v24H0z" />
        <path d="M4.873 3h14.254a1 1 0 0 1 .809.412l3.823 5.256a.5.5 0 0 1-.037.633L12.367 21.602a.5.5 0 0 1-.734 0L.278 9.302a.5.5 0 0 1-.037-.634l3.823-5.256A1 1 0 0 1 4.873 3z" />
      </g>
    </svg>
  )
}

export function FaqIcon({
  size = 24,
  className = "",
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width={size}
      height={size}
      className={className}
      viewBox="0 0 20 20"
    >
      <path
        d="M1.66669 7.49501C1.66625 6.83851 1.79531 6.18837 2.04649 5.58183C2.29767 4.97528 2.66603 4.42424 3.13048 3.96026C3.59492 3.49628 4.14633 3.12847 4.75313 2.8779C5.35993 2.62733 6.01019 2.49891 6.66669 2.50001H13.3334C16.0942 2.50001 18.3334 4.74584 18.3334 7.49501V17.5H6.66669C3.90585 17.5 1.66669 15.2542 1.66669 12.505V7.49501ZM16.6667 15.8333V7.49501C16.6645 6.61209 16.3124 5.76604 15.6876 5.14219C15.0629 4.51834 14.2163 4.16755 13.3334 4.16667H6.66669C6.22906 4.16558 5.79552 4.25088 5.39094 4.4177C4.98635 4.58451 4.61867 4.82955 4.30899 5.13877C3.99931 5.44799 3.75371 5.8153 3.58629 6.21963C3.41887 6.62397 3.33291 7.05738 3.33335 7.49501V12.505C3.33556 13.3879 3.68762 14.234 4.3124 14.8578C4.93719 15.4817 5.78377 15.8325 6.66669 15.8333H16.6667ZM11.6667 9.16667H13.3334V10.8333H11.6667V9.16667ZM6.66669 9.16667H8.33335V10.8333H6.66669V9.16667Z"
        fill="currentColor"
      ></path>
    </svg>
  )
}

export function AffiliatesIcon({
  size = 24,
  className = "",
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="currentColor" fillRule="evenodd">
        <path
          d="M10.06 4.5c-1.064 0-1.946.252-2.646.756-.742.534-1.106 1.26-1.106 2.194 0 .92.378 1.63 1.148 2.12.308.178 1.064.46 2.296.875 1.106.356 1.764.593 1.988.711.63.341.952.8.952 1.394 0 .474-.224.845-.672 1.112-.448.267-1.05.415-1.806.415-.84 0-1.456-.163-1.862-.49-.448-.355-.728-.963-.84-1.793H6c.084 1.334.532 2.312 1.358 2.935.686.504 1.638.771 2.856.771 1.26 0 2.24-.267 2.94-.8.7-.55 1.05-1.29 1.05-2.24 0-.978-.434-1.734-1.288-2.282-.392-.252-1.274-.593-2.618-1.038-.938-.296-1.512-.519-1.736-.652-.504-.282-.742-.652-.742-1.127 0-.534.21-.919.644-1.156.35-.208.854-.311 1.512-.311.756 0 1.316.148 1.708.46.392.296.644.8.784 1.482h1.512c-.098-1.157-.49-2.002-1.19-2.55-.658-.534-1.568-.786-2.73-.786z"
          fillRule="nonzero"
        ></path>
        <path d="M10.917.833V5H9.25V.833a.833.833 0 1 1 1.667 0zM10.917 19.167V15H9.25v4.167a.833.833 0 1 0 1.667 0z"></path>
        <path
          d="M7 1.512v1.612a7.502 7.502 0 0 0 0 13.752v1.612A9.004 9.004 0 0 1 7 1.512zM19 10a9.004 9.004 0 0 1-6 8.488v-1.612a7.502 7.502 0 0 0 0-13.752V1.512A9.004 9.004 0 0 1 19 10z"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  )
}

export function TelegramIcon({
  size = 24,
  className = "",
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 192 192"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={className}
    >
      <path
        stroke="currentColor"
        strokeWidth="12"
        d="M23.073 88.132s65.458-26.782 88.16-36.212c8.702-3.772 38.215-15.843 38.215-15.843s13.621-5.28 12.486 7.544c-.379 5.281-3.406 23.764-6.433 43.756-4.54 28.291-9.459 59.221-9.459 59.221s-.756 8.676-7.188 10.185c-6.433 1.509-17.027-5.281-18.919-6.79-1.513-1.132-28.377-18.106-38.214-26.404-2.649-2.263-5.676-6.79.378-12.071 13.621-12.447 29.891-27.913 39.728-37.72 4.54-4.527 9.081-15.089-9.837-2.264-26.864 18.483-53.35 35.835-53.35 35.835s-6.053 3.772-17.404.377c-11.351-3.395-24.594-7.921-24.594-7.921s-9.08-5.659 6.433-11.693Z"
      />
    </svg>
  )
}

export function XIcon({
  size = 18,
  className = "",
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 16 16"
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z"></path>
    </svg>
  )
}

export function MyCollectionIcon({
  size = 24,
  className = "",
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      fill="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 11.9998H18.6361C17.9781 11.9998 17.6491 11.9998 17.3578 12.1296C17.0665 12.2593 16.8463 12.504 16.4059 12.9932L15.3767 14.1369C15.0154 14.5382 14.8348 14.7389 14.6057 14.734C14.3766 14.7291 14.2049 14.521 13.8616 14.1048L10.3334 9.82819C10.0133 9.44017 9.85321 9.24615 9.63599 9.23311C9.41877 9.22006 9.23663 9.39352 8.87237 9.74044L7.36897 11.1723C6.93986 11.5809 6.7253 11.7853 6.45709 11.8926C6.18887 11.9998 5.89258 11.9998 5.3 11.9998H3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.96173 18.9108L9.42605 18.3219L8.96173 18.9108ZM12 5.5006L11.4596 6.0207C11.601 6.1676 11.7961 6.2506 12 6.2506C12.2039 6.2506 12.399 6.1676 12.5404 6.0207L12 5.5006ZM15.0383 18.9109L15.5026 19.4999V19.4999L15.0383 18.9109ZM12 20.4859L12 19.7359L12 20.4859ZM2.65666 13.3964C2.87558 13.748 3.33811 13.8556 3.68974 13.6367C4.04137 13.4178 4.14895 12.9552 3.93003 12.6036L2.65666 13.3964ZM6.52969 15.7718C6.23645 15.4793 5.76158 15.4798 5.46903 15.7731C5.17649 16.0663 5.17706 16.5412 5.47031 16.8337L6.52969 15.7718ZM2.75 9.13707C2.75 6.33419 4.00722 4.59507 5.57921 3.99711C7.15546 3.39753 9.35129 3.8302 11.4596 6.0207L12.5404 4.9805C10.1489 2.49583 7.3447 1.72069 5.04591 2.59512C2.74286 3.47116 1.25 5.88785 1.25 9.13707H2.75ZM15.5026 19.4999C16.9949 18.3234 18.7837 16.7461 20.2061 14.9838C21.6126 13.2412 22.75 11.2089 22.75 9.13703H21.25C21.25 10.688 20.3777 12.3829 19.0389 14.0417C17.716 15.6807 16.0239 17.1788 14.574 18.3219L15.5026 19.4999ZM22.75 9.13703C22.75 5.88784 21.2571 3.47115 18.9541 2.59511C16.6553 1.7207 13.8511 2.49583 11.4596 4.9805L12.5404 6.0207C14.6487 3.8302 16.8445 3.39753 18.4208 3.99711C19.9928 4.59506 21.25 6.33418 21.25 9.13703H22.75ZM8.49742 19.4998C9.77172 20.5044 10.6501 21.2359 12 21.2359L12 19.7359C11.2693 19.7359 10.8157 19.4174 9.42605 18.3219L8.49742 19.4998ZM14.574 18.3219C13.1843 19.4174 12.7307 19.7359 12 19.7359L12 21.2359C13.3499 21.2359 14.2283 20.5044 15.5026 19.4999L14.574 18.3219ZM3.93003 12.6036C3.18403 11.4054 2.75 10.2312 2.75 9.13707H1.25C1.25 10.617 1.83054 12.0695 2.65666 13.3964L3.93003 12.6036ZM9.42605 18.3219C8.50908 17.599 7.49093 16.7307 6.52969 15.7718L5.47031 16.8337C6.48347 17.8445 7.54819 18.7515 8.49742 19.4998L9.42605 18.3219Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function DiscordIcon({
  size = 24,
  className = "",
}: {
  size?: number
  className?: string
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      color="currentColor"
      className={className}
    >
      <path
        d="M9.60216 5.44677C9.60216 5.44677 10.7148 5.21397 12.0001 5.21397C13.2853 5.21397 14.398 5.44677 14.398 5.44677L14.8429 4.52891C14.9369 4.33509 15.1436 4.22196 15.3548 4.25602C17.5009 4.60213 19.5009 5.75 19.5009 5.75C19.5009 5.75 21.9992 8.25 21.9992 17.0673C22.0003 17.2261 21.9264 17.3801 21.7985 17.4725C20.1581 18.6572 18.1658 19.4353 17.362 19.7224C17.149 19.7985 16.9157 19.7127 16.7942 19.5205L16.2317 18.6301C16.0777 18.3864 16.1577 18.0622 16.407 17.9198L17.5824 17.2483L17.1069 16.8731C17.1069 16.8731 15.205 18.0247 12.0001 18.0247C8.79513 18.0247 6.89318 16.8731 6.89318 16.8731L6.4177 17.2483L7.59311 17.9198C7.84237 18.0622 7.92236 18.3864 7.76839 18.6301L7.20588 19.5205C7.08443 19.7127 6.85111 19.7985 6.63812 19.7224C5.83436 19.4353 3.84203 18.6572 2.20165 17.4725C2.07371 17.3801 1.99986 17.2261 2.00086 17.0673C2.00086 8.25 4.50085 5.75 4.50085 5.75C4.50085 5.75 6.50085 4.60187 8.64535 4.25602C8.8565 4.22196 9.0632 4.33509 9.15717 4.52891L9.60216 5.44677ZM17.2509 12.75C17.2509 13.8546 16.4674 14.75 15.5009 14.75C14.5344 14.75 13.7509 13.8546 13.7509 12.75C13.7509 11.6454 14.5344 10.75 15.5009 10.75C16.4674 10.75 17.2509 11.6454 17.2509 12.75ZM8.50085 14.75C9.46735 14.75 10.2509 13.8546 10.2509 12.75C10.2509 11.6454 9.46735 10.75 8.50085 10.75C7.53436 10.75 6.75085 11.6454 6.75085 12.75C6.75085 13.8546 7.53436 14.75 8.50085 14.75Z"
        fill="currentColor"
        fillRule="evenodd"
      ></path>
    </svg>
  )
}
